import { UnorderedList, ListItem } from '@chakra-ui/react';
import HeaderAviso from './HeaderAviso';
import { ContenedorAviso, ContenidoAviso } from './moleculas/ContenedorAviso';
import { CabeceraSeccion, TextoAviso } from './moleculas/ElementosAvisos';

const TerminosUso = () => {
  return (
    <ContenedorAviso>
      <HeaderAviso
        titulo='Términos de uso'
        subtitulo='Últ. Revisión: 14/03/2024'
      />
      <ContenidoAviso>
        <CabeceraSeccion>
          1. Servicios Financieros Progreso S.A.
        </CabeceraSeccion>
        <TextoAviso>
          <TextoAviso as={'span'} fontWeight={'semibold'}>
            Servicios Financieros Progreso S.A.
          </TextoAviso>
          , en adelante “Progreso”, bajo su calidad de responsable de los datos,
          de acuerdo con la información que le será proporcionada por los
          Usuarios y/o aquella que es obtenida por medios lícitos; será
          utilizada para la obtención y procesamiento de cierta información que
          Progreso ha definido como necesaria para sus procedimientos de
          evaluación comercial, financiera, de riesgo, legal, o para efectos de
          contratación. Los datos o información que es proporcionada por el
          Usuario, podrán ser captados por la plataforma de Progreso denominada
          Temba, que es utilizada como herramienta o producto destinado a
          facilitar el envío de solicitudes o requerimientos por parte del
          Usuario para la obtención de los servicios que ofrece Progreso.
        </TextoAviso>
        <CabeceraSeccion>
          2. Los datos son tuyos o de tu sociedad
        </CabeceraSeccion>
        <TextoAviso>
          Para nosotros tu confianza y la seguridad de tus datos son una
          prioridad. Nos comprometemos a ser transparentes sobre los datos que
          obtenemos bajo la Ley o con tu consentimiento, y la forma en que los
          utilizamos.
        </TextoAviso>
        <TextoAviso>
          Por favor, revisa atentamente este documento para que comprendas qué
          datos obtendremos, con qué fin serán utilizados y con quienes podrían
          ser compartidos.
        </TextoAviso>
        <TextoAviso>
          Los datos que en esta etapa estamos solicitando han sido considerados
          como necesarios por el Destinatario. En caso de que no estés de
          acuerdo, te pedimos no continuar con el proceso.
        </TextoAviso>
        <CabeceraSeccion>
          3. Debes tener poderes de representación
        </CabeceraSeccion>
        <TextoAviso>
          Al aceptar estos términos y condiciones de uso, declaras actuar a tu
          nombre o, en su caso, a nombre y representación de una sociedad u
          organización debidamente constituida, y que tienes facultades legales
          y contractuales suficientes para obligarte u obligar a esa entidad a
          cumplir con este acuerdo.
        </TextoAviso>
        <CabeceraSeccion>4. Mandato especial</CabeceraSeccion>
        <UnorderedList spacing={3}>
          <ListItem>
            Al ingresar tus credenciales de acceso a fuentes de información, nos
            otorgas un mandato especial con representación, delegable y
            revocable, para acceder a dichas fuentes a tu nombre o, en su caso,
            a nombre de la sociedad u organización que representas.
          </ListItem>
          <ListItem>
            Nos autorizas para extraer datos tuyos o aquellos relativos a la
            sociedad u organización que representas y a almacenarlos en nuestra
            base de datos, para poder realizar un procesamiento automatizado de
            datos.
          </ListItem>
          <ListItem>
            Este mandato especial únicamente nos permite acceder y extraer
            información. No haremos transacciones, declaraciones,
            rectificaciones ni ninguna otra actividad distinta del acceso,
            extracción y procesamiento no transaccional de información, salvo
            que lo autorices expresamente.
          </ListItem>
          <ListItem>
            Sólo accedemos, extraemos y procesaremos la información con el fin
            último de cumplir el / los mandato(s) que nos has entregado.
          </ListItem>
          <ListItem>
            Rendiremos cuenta de este mandato, en caso que sea requerido por el
            Usuario, para lo cual se le proveerá de los medios técnicos
            necesarios, con el fin de que cuente con conocimiento sobre cuándo y
            cómo se accede y procesa su información.
          </ListItem>
        </UnorderedList>

        <CabeceraSeccion>
          5. Para qué recopilamos y tratamos la información que nos proporcionas
        </CabeceraSeccion>

        <UnorderedList>
          <ListItem>
            Como procedimiento previo a una evaluación comercial, financiera o
            tributaria que realice el Destinatario, que tú luego podrás o no
            autorizar, verificaremos tu identidad y la de la sociedad u
            organización que representas, en caso de que aplique. También
            utilizaremos esa información para la prevención de delitos y
            fraudes, y para otros fines que nos hayas autorizado explícitamente
            o que sean permitidos por la ley.
          </ListItem>
          <ListItem>
            Nos autorizas expresamente para contactarnos contigo y/o tu sociedad
            con el fin de interactuar en el contexto de la prestación asociada a
            este documento
          </ListItem>
          <ListItem>
            Adicionalmente, podremos realizar actividades de prospección
            comercial y de publicidad, que incluyen informarte sobre ofertas,
            promociones, beneficios, concursos y publicidad de productos y
            servicios asociados a la prestación descrita en este contrato y que
            consideremos que podrían ser de tu interés, y/o productos o
            servicios en relación con la industria en la que participas.
          </ListItem>
          <ListItem>
            Podremos disociar o anonimizar tu información, de manera que no
            pueda ser identificada por terceros contigo, o con la sociedad u
            organización que representas, y utilizarla para entrenamiento de
            algoritmos y sistemas informáticos, así como para hacer análisis
            estadístico.
          </ListItem>
          <ListItem>
            El tiempo de conservación de tus datos será indeterminado, hasta que
            decidas revocar tu autorización y/o nos solicites eliminarlos.
          </ListItem>
        </UnorderedList>
        <CabeceraSeccion>
          6. Información que recopilamos y para qué la utilizamos
        </CabeceraSeccion>
        <TextoAviso>
          Dependiendo de la finalidad para la cual sean requeridos tus datos,
          podríamos obtener información para facilitar procesos de contratación,
          de evaluación financiera, oportunidades de compra, venta e
          intermediación de productos y servicios, de prevención de delitos y
          fraudes, y para otros fines que nos hayas autorizado expresamente o
          que sean permitidos por la Ley.
        </TextoAviso>
        <TextoAviso>
          Sin perjuicio de lo anterior, en particular utilizaremos la
          información detallada a continuación con las siguientes finalidades u
          otras que, de tiempo en tiempo, nos autorices expresamente:
        </TextoAviso>
        <CabeceraSeccion>7. Encargados de tratamiento</CabeceraSeccion>
        <TextoAviso>
          En la realización de las finalidades descritas, podremos compartir tu
          información bajo encargo, en el territorio nacional o fuera de él, y
          siempre sujeto a medidas de seguridad, con AMAZON WEB SERVICES, INC.,
          ubicado en 410 Terry Avenue North, Seattle, WA, Estados Unidos, que
          resguarda tu información de manera encriptada, y con otras empresas o
          personas que tú nos autorices explícitamente.
        </TextoAviso>
        <TextoAviso>
          En caso de que hubiera nuevos terceros encargados del tratamiento, te
          informaremos oportunamente mediante correo electrónico.
        </TextoAviso>
        <CabeceraSeccion>8. Cómo protegemos tu información</CabeceraSeccion>
        <UnorderedList>
          <ListItem>
            Tu información está sujeta a medidas de seguridad de carácter legal,
            organizacional y técnico exigidas por la normativa local.
          </ListItem>
          <ListItem>
            Nuestros procesos siguen la norma ISO 27001 sobre confidencialidad,
            integridad y disponibilidad de la información.
          </ListItem>
          <ListItem>
            Tu información siempre viaja y es almacenada de manera encriptada,
            con los más altos estándares de seguridad disponibles.
          </ListItem>
          <ListItem>
            Tu información es almacenada de forma aislada en bóvedas digitales
            provistas por Amazon Web Services, Inc., que no son compartidas con
            ninguna otra empresa o entidad que no esté legitimada para acceder a
            esos datos.
          </ListItem>
          <ListItem>
            No comunicaremos información que pueda identificarte, o a la
            sociedad u organización que representas, sin tu autorización
            explícita.
          </ListItem>
          <ListItem>
            Todas nuestras plataformas y servicios operan en una infraestructura
            cloud de clase mundial, que cumple con la normativa aplicable sobre
            seguridad de la información.
          </ListItem>
          <ListItem>
            La infraestructura física sobre la que operamos es escalable, tiene
            un diseño de alta disponibilidad, uptime promedio mensual sobre el
            99,9% y funcionalidad de tolerancia de errores integrada. Además, la
            infraestructura no tiene períodos de mantenimiento o inactividad
            programados.
          </ListItem>
          <ListItem>
            Auditamos y revisamos nuestros procedimientos de seguridad de forma
            permanente.
          </ListItem>
          <ListItem>
            Nos reservamos el derecho de exigir sistemas de autenticación más
            robustos para que puedas acceder a tu información, como doble
            factor, tokens, biometría u otros, con el objetivo de reducir al
            máximo el riesgo de suplantación y de acceso ilegal.
          </ListItem>
        </UnorderedList>
        <CabeceraSeccion>9. Cuáles son tus derechos</CabeceraSeccion>
        <UnorderedList>
          <ListItem>
            Siempre podrás conocer qué información tuya o de la sociedad u
            organización que representas hemos recopilado y procesado, para qué
            la hemos procesado, con quien la hemos compartido (con tu
            autorización) y cuándo lo hicimos.
          </ListItem>
          <ListItem>
            Siempre tendrás derecho a solicitar una copia del documento
            electrónico que acredita tu autorización explícita para acceder y
            procesar tu información.
          </ListItem>
          <ListItem>
            Siempre podrás solicitar que dejemos de compartir tu información con
            determinado tercero indicado por ti.
          </ListItem>
          <ListItem>
            Siempre podrás solicitar revocar tu autorización para tratamiento de
            datos, que eliminemos tu información y/o que la disociemos, de
            manera tal que no se pueda vincular a ti, o a la sociedad u
            organización que representas.
          </ListItem>
          <ListItem>
            Puedes ejercer tus derechos que otorga el actual ordenamiento
            jurídico chileno, dirigiendo una solicitud a: privacidad@progreso.cl
          </ListItem>
        </UnorderedList>
      </ContenidoAviso>
    </ContenedorAviso>
  );
};

export default TerminosUso;
